export default function getPriceTotal(product, quantity) {
  const { priceWithDiscount, price } = product || {};
  if (!quantity || !price) {
    return null;
  }
  return (priceWithDiscount || price) * quantity;
}
